import * as React from "react";
const SvgCollapseArrowGreen = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 12" {...props}><path fill="none" stroke="currentColor" strokeWidth={1.8} d="M17.97 1.485 9.486 9.971 1 1.485" /></svg>;
export default SvgCollapseArrowGreen;